import React, { useEffect } from 'react';
import './GameShowView.css';

export const GameShowView = ({ results, showGradient }) => {
    // hide gradient background for fields block in case nothing rendered
    useEffect(() => {
        const resultsPresent = Array.isArray(results) && results.length > 0;
        showGradient(resultsPresent);
    }, [results]);

    return (results && <div className="game-type__game-show game-show-result">
        {results.map((result, index) => {
            return (
                <div className="game-show-result__item" key={index}>{result}</div>
            );
        })}
    </div>
    );
};
